import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import Loading from '../components/Loading'
import NotAuthorisedPage from '../containers/NotAuthorisedPage'
import NotVerifiedPage from '../containers/NotVerifiedPage'

@inject('user')
@observer
class AuthorisationHandler extends Component {
  componentDidMount () {
    const {user} = this.props
    user.setToken(user.token)
  }

  render () {
    const {
      user,
      children,
      check_if_confirmed
    } = this.props

    if (!user.login) {
      return (<NotAuthorisedPage/>)
    }

    if (check_if_confirmed && !user.confirmed) {
      return (<NotVerifiedPage email={user.email}/>)
    }

    return children
  }
}

AuthorisationHandler.defaultProps = {
  check_if_confirmed: false
}

AuthorisationHandler.propTypes = {
  check_if_confirmed: PropTypes.bool,
  user: MobxPropTypes.observableObject,
  children: PropTypes.node
}

export default AuthorisationHandler



// WEBPACK FOOTER //
// ./src/components/AuthorisationHandler.js